import { DataStatus } from '@/shared/lib';
import type { ProductDTO } from '../api/types';
import type { ApplicationPlatform, Product } from '../model/types';

export const mapProduct = (dto: ProductDTO): Product => {
  return {
    id: dto.id,
    name: dto.name,
    logoUrl: dto.logoUrl ?? undefined,
    applicationPlatforms: Array.from(
      new Set(dto.applications.map((a) => a.platform)),
    ) as ApplicationPlatform[],
    applicationLogos: dto.applications.flatMap((a) =>
      a.logoUrl ? [{ id: a.id, logoUrl: a.logoUrl }] : [],
    ),
    applications: [],
    applicationsDataStatus: DataStatus.idle,
    webhooks: [],
    webhooksDataStatus: DataStatus.idle,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
